//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    preorder: { type: Boolean, required: true },
    preorderDate: { type: Number, default: -1 },
    sku: { type: String, required: true }
  },
  computed: {
    delayedDespatchDate () {
      return this.$store.getters['product/delayedDespatchDate'](this.sku)
    }
  }
}
